export default __webpack_public_path__ + "images/btcIcon_e74899.svg";